import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core/styles/createMuiTheme';

export const createMuiPickersCalendarOverrides = ({
    spacing
}: Theme): MuiPickersOverrides['MuiPickersCalendar'] => ({
    transitionContainer: {
        width: '100%',
        minWidth: 330,
        marginTop: 0,
        marginBottom: spacing(2.18),
        minHeight: '223.5px'
    },
    week: {
        width: '100%',
        justifyContent: 'space-between',
        padding: spacing(0.1, 2)
    }
});
